module.exports = __webpack_public_path__ + "static/media/work.0aae8f36.jpg";